module.exports = __webpack_public_path__ + "img/939001641_4.0fd29251.jpg";